import React, { useEffect, useRef, useState } from "react";
import { BsChevronBarLeft, BsChevronBarRight, BsGear } from "react-icons/bs";
import MainChat from "./AI/MainChat";
import { useParams } from "react-router-dom";
import NavbarCodespace from "./NavbarCodespace";
import MainCodespaceBody from "./MainCodespaceBody";
import { TbTerminal } from "react-icons/tb";
import Spinner from "../../Components/Spinner";
import OpeningChat from "./AI/OpeningChat";
import DeleteChatModal from "./AI/DeleteChatModal";
import { io } from "socket.io-client";
import BuildChoise from "./BuildChoise";

const MainCodespaces = () => {
  const user_id = sessionStorage.getItem("user_id");
  const { project_id } = useParams();

  const [isSidebarClosed, setIsSidebarClosed] = useState(false);
  const [loadingPage, setLoadingPage] = useState(true);
  const [codebase, setCodebase] = useState(null);
  const [projectName, setProjectName] = useState("")
  const [view, setOpenView] = useState("preview")
  const [chats, setChats] = useState([]);
  const [chatId, setChatId] = useState(null);
  const [activeTab, setActiveTab] = useState("frontend");
  const [selectedFilePath, setSelectedFilePath] = useState("");
  const [actions, setActions] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);
  const [loadingChat, setLoadingChat] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [selectedModel, setSelectedModel] = useState("gpt-oss-120b");
  const [newMexId, setnewMexId] = useState(false)
  const [thinking, setThinking] = useState(false)
  const [loadingActions, setLoadingActions] = useState(false)
  const chatEndRef = useRef(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [microphoneOn, setMicrophoneOn] = useState(false)
  const recognition = useRef(null);
  const pauseTimeout = useRef(null);
  const [context, setContext] = useState(null)
  const [codeThere, setCodeThere] = useState(false)
  const [hasPreview, setHasPreview] = useState(false)
  const [previewUrl, setPreviewUrl] = useState(null)
  const [reloadPrev, setReloadPrev] = useState(false)

  // TOGGLE SIDEBAR
  const handleToggleSidebar = () =>
    setIsSidebarClosed((prev) => !prev);

  // FETCH USER DATA
  const fetchUserData = async () => {
    try {
      const response = await fetch(
        "https://backend.erioon.com/get_specific_project",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id, project_id }),
        }
      );

      if (!response.ok) throw new Error("Failed to fetch user data");

      const data = await response.json();

      if (data.projects) {
        setProjectName(data.projects.project_name);
      }

    } catch (error) {
      console.error(error)

    }
  };

  // GET CODEBASE
  const getCodebase = async () => {
    try {
      const response = await fetch("https://backend.erioon.com/get_codespace", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id, project_id }),
      });

      if (!response.ok) throw new Error("Failed to fetch codebase");

      const data = await response.json();
      setContext(data.context);

      
      if (data.context === "serverless") {
        setPreviewUrl(`https://frnt-${project_id}.erioon.net`)
        try {
          const previewResponse = await fetch(previewUrl, { method: "HEAD" });
          if (previewResponse.ok) {
            setHasPreview(true)
          } else {
            setHasPreview(false)
          }
        } catch (err) {
          setHasPreview(false)
        }
        setHasPreview(true)
        const hasFrontend = data.frontend && Object.keys(data.frontend).length > 0;

        setCodebase({
          frontend: data.frontend || {},
        });


        if (hasFrontend) {
          setCodeThere(true);
          setActiveTab("frontend");
        }
      }


if (data.context === "mobile") {
        setPreviewUrl(`https://mbl-${project_id}.erioon.net`)
        try {
          const previewResponse = await fetch(previewUrl, { method: "HEAD" });
          if (previewResponse.ok) {
            setHasPreview(true)
          } else {
            setHasPreview(false)
          }
        } catch (err) {
          setHasPreview(false)
        }
        setHasPreview(true)
        const hasFrontend = data.mobile && Object.keys(data.mobile).length > 0;

        setCodebase({
          frontend: data.mobile || {},
        });


        if (hasFrontend) {
          setCodeThere(true);
          setActiveTab("frontend");
        }
      }



    } catch (error) {
      console.error("Error fetching codebase:", error);
    }
  };


  // FETCH ALL CHATS
  const fetchChats = async () => {
    try {
      const response = await fetch("https://aiservice.erioon.com/get_chats", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id, project_id }),
      });

      if (response.ok) {
        const result = await response.json();
        const recordsArray = Object.values(result.chats || {});
        setChats(recordsArray);
      }
    } catch (err) {
      console.error("Error fetching chats:", err);
    }
  };

  // FETCH SELECTED FILE CONTENT
  const fetchFileContent = async (filePath) => {
    try {
      const response = await fetch("https://backend.erioon.com/get_file_content", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          user_id,
          project_id,
          filename: filePath,
          layer: activeTab,
        }),
      });

      if (!response.ok) throw new Error("Failed to fetch file content");
      const data = await response.json();
      return data.content || "";
    } catch (error) {
      console.error("Error fetching file content:", error);
      return "";
    }
  };

  // FETCH ACTIONS
  const fetchActions = async () => {
    try {
      const response = await fetch("https://aiservice.erioon.com/stream_building_steps", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id, project_id, chatId }),
      });

      if (response.ok) {
        const result = await response.json();

        if (result.app?.actions) {
          const appActions = result.app.actions;
          setActions(Object.values(appActions));

          if (appActions.hasOwnProperty("OK")) {
            getCodebase();
            setReloadPrev(true)
          }

        }
      }
    } catch (err) {
      console.error("Error fetching actions:", err);
      setActions([]);
    }
  };

  // FORMAT TIMESTAMP
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);
    const now = new Date();

    const isToday =
      date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    const pad = (n) => n.toString().padStart(2, "0");

    if (isToday) {
      return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    } else {
      return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} - ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    }
  };

  // FETCH SELECTED CHAT
  const fetchChat = async (chatId) => {
    setActions([])
    if (!chatId) return;
    setLoadingChat(true);
    try {
      const response = await fetch(
        "https://aiservice.erioon.com/get_specific_chat",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ user_id, chat_id: chatId }),
        }
      );

      if (response.ok) {
        const result = await response.json();
        const chat = result.chat;

        if (chat && chat.messages) {
          const mappedMessages = chat.messages.map((msg) => ({
            _id: msg._id,
            role: msg.role === "assistant" ? "assistant" : "user",
            content: msg.message,
            timestamp: msg.timestamp,
          }));
          setChatMessages(mappedMessages)

          setnewMexId(null)
        } else {
          setChatMessages([]);
        }
      }
    } catch (err) {
      console.error("Error fetching chat:", err);
    } finally {
      fetchActions()
      setTimeout(() => {
        setLoadingChat(false);
      }, 800);
    }
  };

  // SEND MESSAGE
  const sendMessage = async (message) => {
    setMicrophoneOn(false)
    setThinking(true)
    if (!message) return;

    setIsSending(true);

    setChatMessages((prev) => [
      ...prev,
      { _id: `user-${Date.now()}`, role: "user", content: message },
      { _id: `assistant-${Date.now()}`, role: "assistant", content: "" },
    ]);
    setInputValue("");
    try {
      const response = await fetch("https://aiservice.erioon.com/ai_chat_message", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message,
          user_id,
          project_id,
          model: selectedModel,
          chat_id: chatId,
          context: context
        }),
      });

      setThinking(false)

      const clonedResponse = response.clone();
      let responseData = null;
      try {
        responseData = await clonedResponse.json();
        if (responseData.chat_id && !chatId) {
          setChatId(responseData.chat_id);
          setnewMexId(responseData.ai_msg_id);
          setChats((prevChats) => [
            ...prevChats,
            {
              _id: responseData.chat_id,
              chat_name: responseData.chat_name, // Or responseData.chat_name if available
            },
          ]);
        }
      } catch (_) { }

      const reader = response.body.getReader();
      let buffer = "";
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        const chunk = new TextDecoder().decode(value);
        buffer += chunk;

        setChatMessages((prev) => [
          ...prev,
          {
            _id: responseData.ai_msg_id,
            role: "assistant",
            content: responseData.message,
            timestamp: responseData.timestamp,
          },
        ]);
        setnewMexId(responseData.ai_msg_id);
      }

    } catch (err) {
      setThinking(false)
      console.error("Error sending message:", err);
    } finally {
      setThinking(false)
      setIsSending(false);
      fetchFileContent(selectedFilePath);
    }
  };

  // START MICROPHONE
  const handleMicClick = () => {
    if (!recognition.current) return;

    if (!microphoneOn) {
      recognition.current.start();
      setMicrophoneOn(true);
    } else {
      recognition.current.stop();
      setMicrophoneOn(false);
      if (pauseTimeout.current) clearTimeout(pauseTimeout.current);
    }
  };

  // LISTEN TO USER
  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      console.warn("Speech Recognition not supported");
      return;
    }

    if (!recognition.current) {
      recognition.current = new SpeechRecognition();
      recognition.current.continuous = true;
      recognition.current.interimResults = true;
      recognition.current.lang = "en-US";

      recognition.current.onresult = (event) => {
        const transcript = Array.from(event.results)
          .map(result => result[0].transcript)
          .join("");

        setInputValue(transcript);

        if (pauseTimeout.current) clearTimeout(pauseTimeout.current);

        pauseTimeout.current = setTimeout(() => {
          setInputValue((prev) => {
            if (!/[.!?]$/.test(prev.trim())) return prev.trim() + ".";
            return prev;
          });
        }, 2000);
      };

      recognition.current.onerror = (event) => {
        console.error("Speech recognition error:", event.error);
        setMicrophoneOn(false);
      };

      recognition.current.onend = () => {
        if (microphoneOn) recognition.current.start();
      };
    }
  }, [microphoneOn]);


  // OPEN DELETE MODAL FOR CHAT
  const handleDeleteClick = (chat) => {
    setSelectedRecordId(chat._id);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages]);


  const handleSend = () => {
    if (!inputValue.trim()) return;
    sendMessage(inputValue.trim());
    setTimeout(() => {
      fetchActions()
    }, 3000);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };


  useEffect(() => {
    if (!chatId || !user_id || !project_id) return;

    const socket = io("https://websocket-streaming.erioon.com", {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
    });

    socket.on("error", (err) => {
      console.error("❌ Stream error:", err);
    });

    socket.on("update", (data) => {
      if (data.app?.actions) {
        const appActions = data.app.actions;
        setActions(Object.values(appActions));

        if (appActions.hasOwnProperty("OK")) {
          getCodebase();
        }
      }
    });

    socket.on("connect", () => {
      socket.emit("stream_building_steps", { user_id, project_id, chatId });
    });

    return () => {
      socket.disconnect();
    };
  }, [chatId, user_id, project_id]);

  useEffect(() => {
    const fetchAllData = async () => {
      setLoadingPage(true);
      try {
        const promises = [getCodebase()];

        if (context) {
          promises.push(fetchUserData());
          promises.push(fetchChats())
        }

        await Promise.all(promises);
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setTimeout(() => {
          setLoadingPage(false);
        }, 3000);
      }
    };

    fetchAllData();
  }, [project_id, context]);



  return (
    <div className="main_codespaces_cont">
      {loadingPage ? (
        <div className="initializing_project_container">
          <div className="loading_doughnut">
            <i className="loading_doughnut_icon fade-in">
              <TbTerminal />
            </i>

          </div>
          <Spinner loading={true} />
          <div className="alert_mex_cont">
            <p className="initializing_project_title  fade-in">Codespace</p>
            <p className="alert_mex fade-in">powered by Erioon</p>
          </div>

        </div>
      ) : (
        <>
          {codeThere ? (
            <>
              <NavbarCodespace
                projectName={projectName}
                chatId={chatId}
                fetchActions={fetchActions}
                context={context}
              />
              <div className="main_codespaces_cont_body fade-in">

                {loadingChat ? (
                  <div className="main_codespaces_cont_chat">
                    <div className="loading_chat_cont">
                      <div className="loading_chat_ai user_chat_loading"></div>
                      <div className="loading_chat_ai ai_chat_loading"></div>
                      <div className="loading_chat_ai user_chat_loading_second"></div>
                      <div className="loading_chat_ai ai_chat_loading_second"></div>
                    </div>
                    <div className="loading_chat_ai_input_cont">
                      <div className="loading_chat_ai_input"></div>

                    </div>
                  </div>
                ) : (
                  <MainChat
                    isSidebarClosed={isSidebarClosed}
                    chats={chats}
                    fetchChat={fetchChat}
                    setChatMessages={setChatMessages}
                    chatId={chatId}
                    setChatId={setChatId}
                    fetchActions={fetchActions}
                    actions={actions}
                    formatTimestamp={formatTimestamp}
                    chatMessages={chatMessages}
                    isSending={isSending}
                    inputValue={inputValue}
                    newMexId={newMexId}
                    thinking={thinking}
                    setInputValue={setInputValue}
                    chatEndRef={chatEndRef}
                    handleSend={handleSend}
                    handleKeyDown={handleKeyDown}
                    handleDeleteClick={handleDeleteClick}
                    setSelectedRecordId={setSelectedRecordId}
                    setLoadingActions={setLoadingActions}
                    loadingActions={loadingActions}
                    handleMicClick={handleMicClick}
                    microphoneOn={microphoneOn}
                    context={context}
                  />
                )}


                <div
                  className={`toggle_chat_ai ${isSidebarClosed ? "toggle_chat_ai_closed" : "toggle_chat_ai_open"
                    }`}
                  onClick={handleToggleSidebar}
                >
                  <i>
                    {isSidebarClosed ? <BsChevronBarRight /> : <BsChevronBarLeft />}
                  </i>
                </div>

                <MainCodespaceBody
                  isSidebarClosed={isSidebarClosed}
                  codebase={codebase}
                  setCodebase={setCodebase}
                  view={view}
                  setOpenView={setOpenView}
                  getCodebase={getCodebase}
                  fetchFileContent={fetchFileContent}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  selectedFilePath={selectedFilePath}
                  setSelectedFilePath={setSelectedFilePath}
                  context={context}
                  hasPreview={hasPreview}
                  previewUrl={previewUrl}
                  reloadPrev={reloadPrev}
                />
              </div>
            </>

          ) : (
            context ? (
              <OpeningChat
                chatId={chatId}
                fetchActions={fetchActions}
                actions={actions}
                formatTimestamp={formatTimestamp}
                chatMessages={chatMessages}
                isSending={isSending}
                inputValue={inputValue}
                newMexId={newMexId}
                thinking={thinking}
                setInputValue={setInputValue}
                chatEndRef={chatEndRef}
                handleSend={handleSend}
                handleKeyDown={handleKeyDown}
                setLoadingActions={setLoadingActions}
                loadingActions={loadingActions}
                handleMicClick={handleMicClick}
                microphoneOn={microphoneOn}
                context={context}
              />
            ) : (
              <BuildChoise setContext={setContext} />
            )
          )}
        </>
      )}

      <DeleteChatModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        recordObject={chats.find((chat) => chat._id === selectedRecordId)}
        fetchRecords={() => {
          fetchChats();
          setChatId(null);
        }}
        endpoint={"delete_chat"}
        record_type={selectedRecordId}
        message="This action CANNOT be undone. It will permanently delete the chat."

      />

    </div>
  );
};

export default MainCodespaces;
